import React from 'react'
import Spinner from 'react-bootstrap/cjs/Spinner'

const Loader = () => (
    <Spinner style={{ margin: 'auto' }} animation="border" role="status" />
)

export default Loader
